import { useEffect, useState } from "react";
import "./LoginScreen.css";
import { Link, useNavigate } from "react-router-dom";
import { signIn, resendSignUpCode } from "aws-amplify/auth";
import GlueLogo from "../glueLogo";
import { Analytics } from "../../api/analytics";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // ✅ NEW
  const [errorMessage, setErrorMessage] = useState("");
  const [fieldError, setFieldError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("userId");
    sessionStorage.setItem("disclaimerAccepted", "false");
  }, []);

  const validateFields = () => {
    if (!email || !password) {
      setFieldError("Please enter both email and password");
      return false;
    }
    setFieldError("");
    return true;
  };

  const handleSignupClick = () => {
    // Analytics.logEvent("signup_link_clicked", { location: "login_page" });
  };

  const handleLogin = async () => {
    // Analytics.loginAttempt("email");

    if (!validateFields()) return;

    setIsLoading(true);
    setErrorMessage("");

    try {
      const user = await signIn({ username: email, password });

      if (user.nextStep.signInStep === "CONFIRM_SIGN_UP") {
        await resendSignUpCode({ username: email });
        // Analytics.logEvent("pending_email_verification", {
        //   userId: email,
        //   message: "User must verify email",
        // });
        navigate("/verify-email", { state: { email } });

      } else if (user.nextStep.signInStep === "DONE") {
        Analytics.loginSuccess(email);
        localStorage.setItem("userId", email);
        navigate("/glue-dashboard");

      } else if (
        user.nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_SMS_CODE" ||
        user.nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
      ) {
        // Analytics.logEvent("mfa_required", {
        //   userId: email,
        //   method: user.nextStep.signInStep,
        // });
        navigate("/mfa", { state: { user, email, password } });

      } else {
        setErrorMessage("Unexpected sign-in step. Please try again.");
        console.warn("Unhandled signInStep:", user.signInStep);
      }

    } catch (error) {
      console.error("Login error:", error);

      if (error.name !== "UserAlreadyAuthenticatedException") {
        Analytics.loginFailed({
          name: error.name,
          message: error.message,
        });
      }

      if (error.name === "UserAlreadyAuthenticatedException") {
        navigate("/glue-dashboard");
      } else if (error.name === "NotAuthorizedException") {
        setErrorMessage("Incorrect username or password");
      } else if (error.name === "UserNotAuthenticatedException") {
        setErrorMessage("User needs to be authenticated");
      } else {
        setErrorMessage("An error occurred during login");
      }

    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = () => {
    setFieldError("");
    setErrorMessage("");
  };

  // ✅ NEW: Enter key login
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div className="access-global-data-container">
      <div className="login-box">
        <h2 className="login-title">
          <a
            href="https://www.glueid.com"
            style={{ textDecoration: "none" }}
          >
            <GlueLogo height="65" />
          </a>
        </h2>
        <h3 className="login-subtitle">
          The ID that links everything together
        </h3>

        <div className="input-group">
          <input
            type="email"
            placeholder="Email address"
            className="input-field"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              handleInputChange();
            }}
            onKeyDown={handleKeyDown} // ✅ NEW
          />
        </div>

        {/* PASSWORD WITH EYE ICON */}
        <div className="input-group password-group">
          <input
            type={showPassword ? "text" : "password"} // ✅ NEW
            placeholder="Password"
            className="input-field"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              handleInputChange();
            }}
            onKeyDown={handleKeyDown} // ✅ NEW
          />

          <span
            className="toggle-password"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M3 3L21 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <path d="M10 12C10 13.1 10.9 14 12 14" stroke="currentColor" strokeWidth="2" />
                <path d="M1 12C2.7 10.4 7 6.5 12 6.5C17 6.5 21.3 10.4 23 12" stroke="currentColor" strokeWidth="2" />
              </svg>
            ) : (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M1 12C2.7 10.4 7 6.5 12 6.5C17 6.5 21.3 10.4 23 12C21.3 13.6 17 17.5 12 17.5C7 17.5 2.7 13.6 1 12Z" stroke="currentColor" strokeWidth="2" />
                <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
              </svg>
            )}
          </span>
        </div>

        {fieldError && <div className="error-message">{fieldError}</div>}
        {errorMessage && <div className="error-message">{errorMessage}</div>}

        {isLoading && (
          <div style={{ textAlign: "center" }}>
            <div className="spinner"></div>
          </div>
        )}

        <div className="forgot-password">
          <button className="forgot-password-button">
            <Link to="/forget-password" style={{ textDecoration: "none" }}>
              Forgot password?
            </Link>
          </button>
        </div>

        <button
          className="sign-in-button"
          onClick={handleLogin}
          disabled={isLoading}
        >
          Sign in
        </button>

        <div className="account-signup">
          Don't have an Account?
          <Link
            to="/signup"
            onClick={handleSignupClick}
            style={{ textDecoration: "none", paddingLeft: 10 }}
          >
            <span className="sign-up-btn">Sign Up</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;